import fetch from '@/api/fetch'


/** 查询项目列表 */
export const getProjectTreeList = param => fetch.post('/proman/getProTreeList', param);

/** 根据查询条件查询项目人员 */
export const getProUserByQuery = proUser => fetch.post('/pro/user/query', proUser);

/** 根据查询条件统计项目人员 */
export const getProUserStatustics = proUser => fetch.post('/pro/user/statistics', proUser);

/** 更改人员是否管理员 */
export const changeIsAdministration = id => fetch.post(`/pro/user/administration/update/id/${id}`);

/** 更改人员在场/离场状态 */
export const changeWorkersStatus = (id, opTime) => fetch.post(`/pro/user/work/status//update/id/${id}/${opTime}`);

/** 删除项目人员 */
export const deleteProUserById = (id, projectId, type) => fetch.delete(`/pro/user/delete/id/${id}/${projectId}/${type}`);

/** 导出项目人员 */
export const exportProUserByQuery = proUser => fetch.post('/pro/user/query/export', proUser, { responseType: 'blob' });

/** 获取项目人员工资 */
export const getProUserWageList = (projectId, userId) => fetch.get('/pro/user/wage/list', { params: { projectId, userId }});

/** 导出项目人员工资 */
export const exportProUserWageList = (projectId, userId, ids) =>
  fetch.post('/pro/user/wage/export', ids, { params: { projectId, userId }, responseType: 'blob' });

/** 获取项目人员工作状态纪录 */
export const getProUserWorkStatusRecordList = proUserId => fetch.get(`/pro/user/work/status/record/id/${proUserId}`);
/** 人员组织变更 */
export const orgnazitionChange = param => fetch.get(`/pro/user/orgnazitionChange/${param.userIds}/${param.orgnId}/${param.type}`);